import 'regenerator-runtime/runtime'

import './polyfills.ts'

import { RenderGroveBlueprintContent } from '@/core/server-driven-ui'

import { init } from './init'

import './index.css'

window.RenderGroveBlueprintContent = RenderGroveBlueprintContent

init()
